import configuration from '~/configuration';

export function FooterCopyright({ className = '' }) {
  return (
    <p className={className}>
      © Copyright {new Date().getFullYear()} {configuration.site.name}.{' '}
      <br className="sm:hidden" />
      All Rights Reserved.
    </p>
  );
}
